import { gql } from '@apollo/client';

export default gql`
  mutation updateUser(
    $_id: String
    $branch: String
    $roles: String
    $newroles: String
    $title: String
    $phone: String
    $name: String
    $email: String
    $avatar: String
    $department: DepartmentInput
    $employee: EmployeeInput
    $isBranchsAdmin: Boolean
    $isBranchAdmin: Boolean
    $isAccountant: Boolean
    $isDepartAdmin: Boolean
    $isEmployee: Boolean
    $isFinance: Boolean
    $isOperate: Boolean
    $isPurchase: Boolean
    $isEditor: Boolean
    $isAdmin: Boolean
    $isWriter: Boolean
    $isViewer: Boolean
    $verified: Boolean
    $signatureName: String
    $signatureImage: String
  ) {
    updateUser(
      _id: $_id
      branch: $branch
      roles: $roles
      newroles: $newroles
      title: $title
      phone: $phone
      name: $name
      email: $email
      avatar: $avatar
      department: $department
      employee: $employee
      isBranchsAdmin: $isBranchsAdmin
      isBranchAdmin: $isBranchAdmin
      isAccountant: $isAccountant
      isDepartAdmin: $isDepartAdmin
      isEmployee: $isEmployee
      isFinance: $isFinance
      isOperate: $isOperate
      isPurchase: $isPurchase
      isAdmin: $isAdmin
      isEditor: $isEditor
      isWriter: $isWriter
      isViewer: $isViewer
      verified: $verified
      signatureName: $signatureName
      signatureImage: $signatureImage
    ) {
      ok
      message
      error
    }
  }
`;
